// extracted by mini-css-extract-plugin
export default {"zoomModal":"f1-z"};